var jcms = jcms ? jcms : config;

$.fx.speeds._default = 200;

const htmlElement = document.getElementsByTagName('html')[0];
htmlElement.classList.add('js');
htmlElement.classList.remove('no-js');

gsap.registerPlugin(ScrollTrigger);
gsap.config({
  nullTargetWarn: false
});

function isJson(str) {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
}

function isIE() {
  return !!document.documentMode || navigator.appName == 'Microsite Internet Explorer';
}

function objectHasContent(obj) {
  for (i = 0; i < obj.length; i++) {
    if (obj[i].value !== null && obj[i].value !== '') {
      return true;
    }
  }
  return false;
}

function viewportPosition(element, log) {
  if (element instanceof jQuery) {
    element = element.get(0);
  }

  var rect = element.getBoundingClientRect();
  if (log) {
    console.log(rect.height);
    console.log(rect.top, rect.left, rect.bottom, rect.right);
    console.log(window.innerHeight || document.documentElement.clientHeight);
    console.log(window.innerWidth || document.documentElement.clientWidth);
  }

  if (rect.top > (window.innerHeight || document.documentElement.clientHeight)) {
    return 'below';
  } else if (rect.bottom < 0) {
    return 'above';
  } else if (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  ) {
    return 'in';
  } else {
    return 'entered';
  }
}

function inViewport(element, log) {
  if (element instanceof jQuery) {
    element = element.get(0);
  }

  var rect = element.getBoundingClientRect();
  if (log) {
    console.log(rect.top >= 0, rect.left >= 0, rect.bottom <= (window.innerHeight || document.documentElement.clientHeight), rect.right <= (window.innerWidth || document.documentElement.clientWidth));
    console.log(window.innerHeight, document.documentElement.clientHeight);
    console.log(window.innerWidth, document.documentElement.clientWidth);
  }
  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
}

/**
 * Convert form fields into array to use for localStorage
 */
function localStorageData($form) {
  var aLocalStorageData = {};
  var formData = $form.serializeArray();
  formData.forEach(function (data) {
    if (data.name.length > 0 && data.value) {
      if (data.name.match(/\[\]$/)) {
        if (!aLocalStorageData[data.name]) {
          aLocalStorageData[data.name] = [];
        }
        aLocalStorageData[data.name].push(data.value);
      } else {
        aLocalStorageData[data.name] = data.value;
      }
    }
  });

  return JSON.stringify(aLocalStorageData);
}

/**
 * event_tracker
 * Fires either Google Tag Manager or Google Analytics events
 *
 **/
function event_tracker(category, action, label, value) {
  action = action ? action : 'click';

  if (typeof gtag == 'function') {
    var data = {
      'event_category': category,
      'event_label': label,
      'value': value
    };
    gtag('event', action, data);
  } else if (typeof ga == 'function') {
    ga('send', 'event', category, action, label, value);
  }
}


// -- Custom jQuery function to get a cached version of a script
var getCachedScript = function (url, options) {
  // Allow user to set any option except for dataType, cache, and url
  options = $.extend(options || {}, {
    dataType: "script",
    cache: true,
    url: url
  });

  // Use $.ajax() since it is more flexible than $.getScript
  // Return the jqXHR object so we can chain callbacks
  return jQuery.ajax(options);
};


// -- Get URL Parameter function
function getURLParameter(sParam) {
  var sPageURL = window.location.search.substring(1);
  var sURLVariables = sPageURL.split('&');

  for (var i = 0; i < sURLVariables.length; i++) {
    var sParameterName = sURLVariables[i].split('=');
    if (sParameterName[0] == sParam) {
      sParameterName[1] = sParameterName[1].replace('+', ' ');
      return decodeURIComponent(sParameterName[1]);
    }
  }
}

/**
 * Defer loading css styles until after page load
 */
var loadDeferredStyles = function () {
  var addStylesNode = document.getElementById("deferred-styles");
  if (addStylesNode != null) {
    var replacement = document.createElement("div");
    replacement.innerHTML = addStylesNode.textContent;
    document.body.appendChild(replacement);
    addStylesNode.parentElement.removeChild(addStylesNode);
  }
};

var raf = window.requestAnimationFrame || window.mozRequestAnimationFrame ||
  window.webkitRequestAnimationFrame || window.msRequestAnimationFrame;

if (raf) {
  raf(function () {
    window.setTimeout(loadDeferredStyles, 0);
  });
} else {
  window.addEventListener('load', loadDeferredStyles);
}


var htmlOverflow = function (element) {
  if (element.is(':visible')) {
    $('html').css('overflow', 'hidden');
  } else {
    $('html').css('overflow', '');
  }
};


// -- Used for IE to replace btoa function
function encode64(input) {
  var keyStr = "ABCDEFGHIJKLMNOP" +
    "QRSTUVWXYZabcdef" +
    "ghijklmnopqrstuv" +
    "wxyz0123456789+/" +
    "=";
  input = encodeURI(input);
  var output = "";
  var chr1, chr2, chr3 = "";
  var enc1, enc2, enc3, enc4 = "";
  var i = 0;

  do {
    chr1 = input.charCodeAt(i++);
    chr2 = input.charCodeAt(i++);
    chr3 = input.charCodeAt(i++);

    enc1 = chr1 >> 2;
    enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
    enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
    enc4 = chr3 & 63;

    if (isNaN(chr2)) {
      enc3 = enc4 = 64;
    } else if (isNaN(chr3)) {
      enc4 = 64;
    }

    output = output +
      keyStr.charAt(enc1) +
      keyStr.charAt(enc2) +
      keyStr.charAt(enc3) +
      keyStr.charAt(enc4);
    chr1 = chr2 = chr3 = "";
    enc1 = enc2 = enc3 = enc4 = "";
  } while (i < input.length);

  return output;
}


function alertMessage($type, $message) {
  var $alert = $('#alert');
  if ($alert.length) {
    $alert.addClass('alert--' + $type).text($message).slideDown();
    setTimeout(function () {
      $alert.slideUp(function () {
        $alert.removeClass('alert--' + $type).text('');
      });
    }, 3000);
  }
}

// ----------------------------------------------------------------------------
//  scriptLoader
// ----------------------------------------------------------------------------
function scriptLoader(deferredScripts) {
  $(window).on('load', function () {
    setTimeout(function () {
      if (deferredScripts && typeof $ != 'undefined') {
        if (deferredScripts.head && Array.isArray(deferredScripts.head) && deferredScripts.head.length) {
          $('head').find('meta[charset]').after(deferredScripts.head.join(''));
        }

        if (deferredScripts.head_close && Array.isArray(deferredScripts.head_close) && deferredScripts.head_close.length) {
          $('head').append(deferredScripts.head_close.join(''));
        }

        if (deferredScripts.body && Array.isArray(deferredScripts.body) && deferredScripts.body.length) {
          $('body').prepend(deferredScripts.body.join(''));
        }

        if (deferredScripts.footer && Array.isArray(deferredScripts.footer) && deferredScripts.footer.length) {
          $('body').append(deferredScripts.footer.join(''));
        }
      }
    }, 1200);
  });
}


// ----------------------------------------------------------------------------
//  Google reCaptcha
// ----------------------------------------------------------------------------
if (typeof jcms.recaptchaKey != 'undefined' && $('[data-recaptcha]').length) {
  var recaptchas = function () {
    $(function () {
      const $submit = $('[data-recaptcha]');
      $submit.each(function () {
        var $this = $(this);
        grecaptcha.render($(this).get(0), {
          sitekey: jcms.recaptchaKey,
          callback: function (response) {
            if (response) {
              $this.parents('form').submit();
              $this.after('<button type="submit" class="' + $this.attr('class') + '">' + $this.html() + '</button>').remove();
            }
          }
        });
      });

      const $oldForm = $('[name^="dynoForm"]');
      $oldForm.each(function () {
        const $form = $(this);
        const submitButton = $form.find('input[type="submit"]').get(0);

        var lockForm = function (e) {
          e.preventDefault();
          e.stopPropagation();
        }

        $form.data('recaptcha-required', 1).submit(lockForm);

        grecaptcha.render(submitButton, {
          sitekey: jcms.recaptchaKey,
          callback: function (response) {
            if (response) {
              $form.data('recaptcha-verified', 1);
              $form.unbind('submit').submit();
            }
          }
        });
      });
    });
  };

  var recaptchaCallback = function () {
    setTimeout(function () {
      $(".g-recaptcha-response").attr({
        'aria-hidden': 'true',
        'aria-label': 'do not use',
        'aria-readonly': 'true',
      }).before('<label for="g-recaptcha-response" class="sr-only">reCaptcha</label>');
      $('.grecaptcha-logo iframe').attr('title', 'reCaptcha');
      $('iframe').each(function (index) {
        if (!$(this).attr('title')) {
          $(this).attr('title', 'Embed ' + (++index));
        }
        $(this).removeAttr('frameborder').removeAttr('scrolling').removeAttr('width').removeAttr('height');
      });
    }, 1500);
  };

  $(window).on('load', function () {
    if (!config.hidethirdparty) {
      setTimeout(function () {
        // 'https://www.google.com/recaptcha/api.js?render=reCAPTCHA_site_key'
        getCachedScript('//www.google.com/recaptcha/api.js?render=explicit&onload=recaptchaCallback');
      }, 1200);

      var recaptchaLibraryLoaded = setInterval(function () {
        if (typeof grecaptcha != 'undefined' && typeof grecaptcha.render != 'undefined') {
          clearInterval(recaptchaLibraryLoaded);
          recaptchas();
        }
      }, 1000);
    }
  });
}


// ----------------------------------------------------------------------------
//  Google Conversion
// ----------------------------------------------------------------------------
function cmg_google_conversion(sDoGoogleConversion, iConversionId, sImageHtml) {
  //set this to FALSE to skip all of the code in this function (instead of deleting the actual code sample)
  var bDoGoogleConversion = false;
  if (sDoGoogleConversion == 'On') {
    bDoGoogleConversion = true;
  }

  if (bDoGoogleConversion) {
    var google_conversion_id = iConversionId;
    var google_custom_params = window.google_tag_params;
    var google_remarketing_only = true;

    //inject the 1 pixel image onto the page, thus calling the Google tracking
    $('body').append(sImageHtml);
  }

  return true;
}


//  Format US States
// ------------------------------------------------------------------
formatState = function (input, format) {
  if (typeof input === 'undefined') {
    return false;
  }
  var value;
  var states = [
    ['Arizona', 'AZ'],
    ['Alabama', 'AL'],
    ['Alaska', 'AK'],
    ['Arizona', 'AZ'],
    ['Arkansas', 'AR'],
    ['California', 'CA'],
    ['Colorado', 'CO'],
    ['Connecticut', 'CT'],
    ['Delaware', 'DE'],
    ['Florida', 'FL'],
    ['Georgia', 'GA'],
    ['Hawaii', 'HI'],
    ['Idaho', 'ID'],
    ['Illinois', 'IL'],
    ['Indiana', 'IN'],
    ['Iowa', 'IA'],
    ['Kansas', 'KS'],
    ['Kentucky', 'KY'],
    ['Kentucky', 'KY'],
    ['Louisiana', 'LA'],
    ['Maine', 'ME'],
    ['Maryland', 'MD'],
    ['Massachusetts', 'MA'],
    ['Michigan', 'MI'],
    ['Minnesota', 'MN'],
    ['Mississippi', 'MS'],
    ['Missouri', 'MO'],
    ['Montana', 'MT'],
    ['Nebraska', 'NE'],
    ['Nevada', 'NV'],
    ['New Hampshire', 'NH'],
    ['New Jersey', 'NJ'],
    ['New Mexico', 'NM'],
    ['New York', 'NY'],
    ['North Carolina', 'NC'],
    ['North Dakota', 'ND'],
    ['Ohio', 'OH'],
    ['Oklahoma', 'OK'],
    ['Oregon', 'OR'],
    ['Pennsylvania', 'PA'],
    ['Rhode Island', 'RI'],
    ['South Carolina', 'SC'],
    ['South Dakota', 'SD'],
    ['Tennessee', 'TN'],
    ['Texas', 'TX'],
    ['Utah', 'UT'],
    ['Vermont', 'VT'],
    ['Virginia', 'VA'],
    ['Washington', 'WA'],
    ['West Virginia', 'WV'],
    ['Wisconsin', 'WI'],
    ['Wyoming', 'WY'],
  ];

  var state = input.toLowerCase().charAt(0).toUpperCase() + input.slice(1).toLowerCase();

  $.each(states, function (index, array) {
    var name = array[0];
    var abbr = array[1];
    // Check if input matches a State NAME
    if (state === name) {
      value = (format === 'abbr') ? abbr : name;
    }
    // Check if input matches a State ABBREVIATION
    else if (input.toUpperCase() === abbr) {
      value = (format === 'abbr') ? abbr : name;
    }
  });

  return value ? value : false;
};
